import {Markets} from 'models/Market';
import {OfferFiltersDestination} from 'models/OfferFilters';
import {Properties} from 'store/properties/properties.interface';

export const createDestinations = (
  markets: Markets,
  properties: Properties
) => {
  const list = markets.reduce<OfferFiltersDestination[]>(
    (destinations, market) => {
      const destinationProperties = properties
        .filter(property => property.marketCode === market.id)
        .map(property => ({
          id: property.id,
          name: property.name,
        }));
      if (destinationProperties.length) {
        return [
          ...destinations,
          {
            name: market.name,
            id: market.id,
            properties: destinationProperties,
          },
        ];
      }
      return destinations;
    },
    []
  );

  return list;
};
